import { __require as S } from "./main15.js";
import { __require as l } from "./main13.js";
import { __require as c } from "./main16.js";
import { __require as h } from "./main17.js";
import { __require as K } from "./main14.js";
var u, q;
function C() {
  if (q) return u;
  q = 1;
  var d = S(), m = l(), v = c(), a = h(), p = K();
  function x(e, t, g, f) {
    if (!a(e))
      return e;
    t = m(t, e);
    for (var s = -1, o = t.length, I = o - 1, i = e; i != null && ++s < o; ) {
      var r = p(t[s]), _ = g;
      if (r === "__proto__" || r === "constructor" || r === "prototype")
        return e;
      if (s != I) {
        var n = i[r];
        _ = f ? f(n, r, i) : void 0, _ === void 0 && (_ = a(n) ? n : v(t[s + 1]) ? [] : {});
      }
      d(i, r, _), i = i[r];
    }
    return e;
  }
  return u = x, u;
}
export {
  C as __require
};
